// Active deal-draft session — single localStorage key shared between the
// /deals page (writer) and other surfaces (e.g. my-sumo Drafts tab) that need
// to invalidate the session when a draft is deleted server-side.
//
// Stored shape:
//   {
//     step: 1 | 2 | 3,
//     formData: object | null,
//   }
//
// Read is synchronous (works before redux-persist REHYDRATE has fired).
export const DRAFT_KEY = "deal_local_draft";

export const readActiveDraftSession = () => {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
};

export const writeActiveDraftSession = (patch) => {
  try {
    const current = readActiveDraftSession() || {};
    const next = { ...current, ...patch };
    localStorage.setItem(DRAFT_KEY, JSON.stringify(next));
  } catch {
    /* quota / serialization errors — non-fatal */
  }
};

export const clearActiveDraftSession = () => {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch {
    /* ignore */
  }
};

// If the active LS session points at this draftId, clear it.
// Used when a draft is deleted from the dashboard so /deals doesn't re-hydrate
// against a row that no longer exists.
export const clearActiveDraftSessionIfMatches = (draftId) => {
  const current = readActiveDraftSession();
  const activeDraftId = current?.formData?.draftId ?? current?.draftId;
  if (current && activeDraftId === draftId) {
    clearActiveDraftSession();
  }
};
